module.exports = __webpack_public_path__ + "static/media/thanks-ship.a08b84f4.svg";